module.exports = "http://cheyintong-website.oss-cn-beijing.aliyuncs.com/img/app-download-banner-image1.png";